module.exports = __webpack_public_path__ + "img/166.5232e354.jpg";